__turbopack_context__.v({
  "and": "path-trail-module__shyJEa__and",
  "back": "path-trail-module__shyJEa__back",
  "crumb": "path-trail-module__shyJEa__crumb",
  "itemDot": "path-trail-module__shyJEa__itemDot",
  "label": "path-trail-module__shyJEa__label",
  "more": "path-trail-module__shyJEa__more",
  "overflow": "path-trail-module__shyJEa__overflow",
  "overflowCompact": "path-trail-module__shyJEa__overflowCompact",
  "overflowWide": "path-trail-module__shyJEa__overflowWide",
  "parent": "path-trail-module__shyJEa__parent",
  "parents": "path-trail-module__shyJEa__parents",
  "sep": "path-trail-module__shyJEa__sep",
  "step": "path-trail-module__shyJEa__step",
  "trail": "path-trail-module__shyJEa__trail",
  "viewIcon": "path-trail-module__shyJEa__viewIcon",
});
